










import Vue from "vue";
import Shared from "../../../shared";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ShareDocumentLink",
    props: {
        documentId: String,
        quickCode: String
    },
    data: function () {
        return {};
    },
    computed: {
        hasQuickCode(): boolean {
            return this.quickCode && this.quickCode.length > 1;
        },
        link(): string {
            if (this.hasQuickCode) {
                return Shared.iProvaUrl + "/QC/" + this.quickCode;
            } else {
                return location.href.replace(location.hash, "#/document/" + this.documentId);
            }
        }
    },
    methods: {
        async copyLink(): Promise<boolean> {
            this.selectTextToCopy();
            document.execCommand("copy");
            return false;
        },
        selectTextToCopy(): void {
            let textToCopy = (this.$refs.link as Vue).$el.querySelector("input");
            textToCopy.select();
        }
    },
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.copyLink });
    }
});
